/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import {
  BaSeCheckbox,
  BaSeHeading5,
  BaSeInput,
  BaSeParagraph,
  BaSeRadio,
  BaSeSelect,
  BaSeSmall1,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';

import { useCandidateController } from '../../../../hooks/controllers/candidate-controller';
import { convertPrimitiveArrayToObject } from '../../../../utils/arrays';
import { TextWrapper } from '../basic-data/basic-data-styled';
import Button from '../button';
import { useQuestionario } from './hook/useQuestionario';
import {
  Container,
  Content,
  ContentItem,
  ContentText,
} from './question-selection-styled';

import { useAnswerController } from '../../../../hooks/controllers/answer-controller';

const optionsEstagioStartup = [
  {
    id: 1,
    value: 'Estou desenvolvendo uma ideia de startup.',
  },
  {
    id: 2,
    value: 'Estou validando uma ideia de startup.',
  },
  {
    id: 3,
    value: 'Já tenho uma startup com receita de clientes.',
  },
];

const optionsDiferencaStartup = [
  {
    id: 7,
    value: 'Já estudei sobre startup e interajo com outros empreendedores.',
  },
  {
    id: 8,
    value: 'Faço parte de um grupo de empreendedores da minha região.',
  },
  {
    id: 9,
    value: 'Sempre frequento os meetups da minha região.',
  },
  {
    id: 10,
    value: 'Já fui participante de um startup weekend.',
  },
  {
    id: 11,
    value: 'Já fui facilitador de um startup weekend.',
  },
  {
    id: 12,
    value: 'Participo de eventos de startup em outras regiões.',
  },
];

const disponibilityOptions = [
  {
    id: 14,
    value: 'Sim',
  },
  {
    id: 13,
    value: 'Não',
  },
];

const REQUIRED = 'Campo obrigatório não informado.';

const anoAtual = new Date().getFullYear();
const anos = [];

for (let ano = anoAtual; ano >= 1988; ano--) {
  anos.push({ id: ano - 1987, label: ano.toString() });
}

const initialState = {
  stageStartup: { question: { id: null }, questionOption: { id: '' } },
  startupName: { question: { id: 12 }, answer: '' },
  fundationYear: { question: { id: 13 }, answer: 0 },
  cnpj: { question: { id: 14 }, answer: '' },
  site: { question: { id: 15 }, answer: '' },
  insta: { question: { id: 16 }, answer: '' },
  qtdColaboradores: { question: { id: 17 }, answer: 0 },
  startupVinculo: { question: { id: null }, questionOption: { id: '' } },
  textResolvProblem: { question: { id: 19 }, answer: '' },
  optionDisponibility: { question: { id: null }, questionOption: { id: '' } },
};

function QuestionSection({ interview, pageSettings }) {
  const { handleChangeQuestionsForm } = useQuestionario();
  const { getFormQuestions } = useCandidateController();
  const { sendAnswerInterview } = useAnswerController();
  const { navigateTo } = Sebrae.useSebraeRouter();

  React.useEffect(() => {
    getFormQuestions(interview?.module?.id)
      .then((response) => handleChangeQuestionsForm(response))
      .catch((error) => console.log(error));
  }, [getFormQuestions, handleChangeQuestionsForm, interview]);

  const conteudosVinculadosIds = [];

  const [conteudosVinculadosObj, setConteudosVinculadosObj] = React.useState(
    convertPrimitiveArrayToObject(conteudosVinculadosIds),
  );
  const [formValidation, setFormValidation] = React.useState(false);

  const disabledCheckbox = false;
  const [form, setForm] = React.useState(initialState);

  const [fundationYear, setFundationYear] = React.useState({
    id: 13,
    answer: 0,
    idSelect: 0,
  });

  const onChangeConteudoVinculado = (id, estadoAtual) => {
    setConteudosVinculadosObj((value) => ({
      ...value,
      [id]: !estadoAtual,
    }));
  };

  const formatedData = React.useCallback(() => {
    let arr = [];
    for (const chave in conteudosVinculadosObj) {
      if (conteudosVinculadosObj.hasOwnProperty(chave)) {
        if (conteudosVinculadosObj[chave]) {
          arr.push({
            question: { id: 20 },
            questionOption: { id: Number(chave) },
          });
        }
      }
    }

    let answersData = [];

    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        answersData.push(form[key]);
      }
    }

    const data = {
      answers: [...arr, ...answersData],
      idInterview: interview.id,
    };

    return data;
  }, [form, interview, conteudosVinculadosObj]);

  const validDiferenciais = React.useCallback(() => {
    let arr = [];
    for (const chave in conteudosVinculadosObj) {
      if (conteudosVinculadosObj.hasOwnProperty(chave)) {
        arr.push(conteudosVinculadosObj[chave]);
      }
    }
    const value = arr.filter((e) => e).length;
    if (value > 0) {
      return true;
    }
    return false;
  }, [conteudosVinculadosObj]);

  const validationMandatoryFields = React.useCallback(() => {
    setFormValidation(true);

    if (
      form.stageStartup.question.id === null ||
      form.startupVinculo.question.id === null ||
      !validDiferenciais() ||
      form.optionDisponibility.question.id === null ||
      form.qtdColaboradores.answer === ''
    )
      return false;
    return true;
  }, [form, validDiferenciais]);

  const send = React.useCallback(() => {
    if (!validationMandatoryFields()) return;

    const data = formatedData();

    sendAnswerInterview(data, interview?.module?.id)
      .then(() => {
        navigateTo(`/candidato/resultado/id/${data.idInterview}`, {
          keepQueryString: true,
        });
      })
      .catch((error) => {
        console.error('Falha ao enviar entrevista para analise', error);
        navigateTo(`/candidato/resultado/id/${data.idInterview}`, {
          keepQueryString: true,
        });
      });
  }, [
    validationMandatoryFields,
    formatedData,
    sendAnswerInterview,
    interview,
    navigateTo,
  ]);

  return (
    <Container>
      <TextWrapper>
        <BaSeHeading5 isBold color={BaSeTheme.colors.defaultColors.white}>
          Questionário de seleção
        </BaSeHeading5>
        <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          Esta etapa consiste em um questionário em que iremos conhecer um pouco
          mais sobre o perfil da sua startup para assim avaliar sua participação
          no seminário.
        </BaSeHeading5>
      </TextWrapper>
      <Content>
        <ContentItem>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Estágio da startup:
          </BaSeParagraph>
          <div>
            {optionsEstagioStartup.map((option) => (
              <BaSeRadio
                key={option.id}
                checked={form.stageStartup.questionOption.id === option.id}
                onChange={(e) => {
                  setForm({
                    ...form,
                    stageStartup: {
                      question: { id: 11 },
                      questionOption: { id: e },
                    },
                  });
                }}
                color="default"
                id={option.id}
                label={option.value}
                name={option.value}
                size="small"
              />
            ))}
            <>
              {formValidation && form.stageStartup.question.id === null && (
                <BaSeSmall1
                  isItalic
                  color={BaSeTheme.colors.feedbackInterface.erro35}
                >
                  {REQUIRED}
                </BaSeSmall1>
              )}
            </>
          </div>
        </ContentItem>

        <ContentItem>
          <BaSeInput
            label="Nome da startup:"
            placeholder=""
            value={form.startupName.answer}
            onChange={(value) =>
              setForm({
                ...form,
                startupName: { ...form.startupName, answer: value },
              })
            }
          />
        </ContentItem>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 20px',
          }}
        >
          <BaSeSelect
            label="Ano fundação:"
            width="48%"
            values={anos}
            selectedValueId={fundationYear.idSelect}
            onChange={(e) => {
              setFundationYear({ id: 13, idSelect: e.id });
              setForm({
                ...form,
                fundationYear: {
                  question: { id: 13 },
                  answer: isNaN(Number(e.label)) ? 0 : Number(e.label),
                },
              });
            }}
          />

          <BaSeInput
            label="CNPJ:"
            placeholder=""
            value={form.cnpj.answer}
            onChange={(value) =>
              setForm({ ...form, cnpj: { ...form.cnpj, answer: value } })
            }
            mask="cnpj"
            inputMode="text"
            width={'48%'}
          />
        </div>

        <ContentItem>
          <BaSeInput
            label="Site:"
            placeholder=""
            value={form.site.answer}
            onChange={(value) =>
              setForm({ ...form, site: { ...form.site, answer: value } })
            }
          />
        </ContentItem>

        <ContentItem>
          <BaSeInput
            label="Instagram:"
            placeholder=""
            value={form.insta.answer}
            onChange={(value) =>
              setForm({ ...form, insta: { ...form.insta, answer: value } })
            }
          />
        </ContentItem>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 20px',
          }}
        >
          <BaSeInput
            label="Nº Colaboradores:"
            placeholder=""
            inputMode="decimal"
            value={form.qtdColaboradores.answer.toString()}
            onChange={(value) => {
              const newValue = Number(value);
              if (value === '') {
                setForm({
                  ...form,
                  qtdColaboradores: { ...form.qtdColaboradores, answer: '' },
                });
                return;
              }
              if (isNaN(newValue)) return;

              setForm({
                ...form,
                qtdColaboradores: {
                  ...form.qtdColaboradores,
                  answer: newValue,
                },
              });
            }}
            width={'48%'}
            complement={
              formValidation &&
              form.qtdColaboradores.answer === '' && (
                <BaSeParagraph
                  isItalic
                  color={BaSeTheme.colors.feedbackInterface.erro35}
                >
                  {REQUIRED}
                </BaSeParagraph>
              )
            }
          />

          <BaSeSelect
            label="Vínculo com a startup:"
            width="48%"
            complement={
              formValidation &&
              form.startupVinculo.question.id === null && (
                <BaSeParagraph
                  isItalic
                  color={BaSeTheme.colors.feedbackInterface.erro35}
                >
                  {REQUIRED}
                </BaSeParagraph>
              )
            }
            values={[
              { id: 4, label: 'Sócio fundador' },
              { id: 5, label: 'Colaborador' },
              { id: 6, label: 'Outro' },
            ]}
            onChange={(e) => {
              setForm({
                ...form,
                startupVinculo: {
                  question: { id: 18 },
                  questionOption: { id: e.id },
                },
              });
            }}
            selectedValueId={form.startupVinculo.questionOption.id}
          />
        </div>

        <ContentText>
          <BaSeTextArea
            hasCounter="words"
            placeholder="Descreva aqui..."
            onChange={(value) => {
              setForm({
                ...form,
                textResolvProblem: { ...form.textResolvProblem, answer: value },
              });
            }}
            rows={8}
            textSize="medium"
            value={form.textResolvProblem.answer}
            label="Qual problema sua startup resolve e qual a sua proposta de solução?"
            counterMaxLength={200}
          />
        </ContentText>

        <ContentText>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Sinalize seus diferenciais no ambiente startup:
          </BaSeParagraph>
          <div>
            {optionsDiferencaStartup.map((option) => (
              <BaSeCheckbox
                key={option.id}
                disabled={
                  !conteudosVinculadosObj[option.id] && disabledCheckbox
                }
                align="top-left"
                color="default"
                label={option.value}
                onChange={(e) => {
                  onChangeConteudoVinculado(
                    option.id,
                    conteudosVinculadosObj[option.id],
                  );
                }}
                size="medium"
                checked={conteudosVinculadosObj[option.id]}
              />
            ))}
            <>
              {formValidation && !validDiferenciais() && (
                <BaSeSmall1
                  isItalic
                  color={BaSeTheme.colors.feedbackInterface.erro35}
                >
                  {REQUIRED}
                </BaSeSmall1>
              )}
            </>
          </div>
        </ContentText>
        <ContentItem>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            O Empretec Startup consumirá tempo integral durante os 5 dias do
            seminário, tanto no período em sala quanto fora dela. Você tem a
            disponibilidade de tempo necessária para participar integralmente?
          </BaSeParagraph>
          <div>
            {disponibilityOptions.map((option) => (
              <BaSeRadio
                checked={
                  option.id === form.optionDisponibility.questionOption.id
                }
                key={option.id}
                onChange={(e) => {
                  setForm({
                    ...form,
                    optionDisponibility: {
                      question: { id: 21 },
                      questionOption: { id: e },
                    },
                  });
                }}
                color="default"
                id={option.id}
                label={option.value}
                name={option.value}
                size="small"
              />
            ))}
            <>
              {formValidation &&
                form.optionDisponibility.question.id === null && (
                  <BaSeSmall1
                    isItalic
                    color={BaSeTheme.colors.feedbackInterface.erro35}
                  >
                    {REQUIRED}
                  </BaSeSmall1>
                )}
            </>
          </div>
        </ContentItem>
      </Content>
      <Button
        calback={send}
        value="ENVIAR QUESTIONÁRIO"
        valueSmall="ENVIAR QUESTIONÁRIO"
        color={pageSettings?.buttonColor}
        withBorder={true}
        borderColor={pageSettings?.buttonBorderColor}
      />
    </Container>
  );
}

export default QuestionSection;
